"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = Slider;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Slider({
  color,
  max,
  min,
  onChange,
  step,
  testId,
  value,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledInput, _extends({
    color: color,
    "data-testid": testId,
    max: max,
    min: min,
    onChange: onChange,
    step: step,
    type: "range",
    value: value
  }, props));
}